import React from 'react'
import Classes from '../../ViewOrderPage.module.css'

export default function Sidebar({ activeTab, setActiveTab }) {
    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "details" ? Classes.active : ""}
                onClick={() => setActiveTab("details")}>
                <h5>Details</h5>
            </li>

            <li className={activeTab === "tasks" ? Classes.active : ""}
                onClick={() => setActiveTab("tasks")}>
                <h5>Tasks</h5>
            </li>

            <li className={activeTab === "files" ? Classes.active : ""}
                onClick={() => setActiveTab("files")}>
                <h5>Files</h5>
            </li>
        </ul>
    )
}
